export interface defaultStateInterface {
  eligibilityQueues: {
    [queuName: string]: boolean
  },
  greetingMessagesForQueue: {
    [queueName: string]: {
      AuthenticatedCustomerMessage : string,
      ReturnCustomerMessage : string,
      TransferredCustomerMessage : string,
      UnauthenticatedCustomerMessage : string,
    }
  }
}

const defaultState: defaultStateInterface = {
  eligibilityQueues: {},
  greetingMessagesForQueue: {}
}

const greetingMessageReducer = (state: defaultStateInterface = defaultState, action: any) => {
  switch (action.type) {
    case 'SET_QUEUE_GREETING_MESSAGE_ELIGIBILITY':
      return {
        ...state,
        eligibilityQueues: {
          ...state.eligibilityQueues,
          [action?.payload?.queueName]: action?.payload?.eligibility
        }
      }
    case 'SET_GREETING_MESSAGES_FOR_QUEUE':
      return {
        ...state,
        greetingMessagesForQueue: {
          ...state.greetingMessagesForQueue,
          [action?.payload?.queueName]: action?.payload?.greetingMessages
        }
      }
    default:
      return state
  }
}

export default greetingMessageReducer